// Per-device memory of the last MFA factor resolved, to pick which challenge is
// offered first. Never gates access: "try another way" always reaches the other.

const LAST_USED_FACTOR_STORAGE_KEY = 'zippedi.mfa.lastUsedFactor';

// Literals, not PhoneMultiFactorGenerator.FACTOR_ID: some SDK builds leave that
// static undefined, which would silently reject a valid 'phone' value.
const VALID_FACTORS = ['phone', 'totp'];

export function rememberLastUsedFactor(factorId) {
  if (!VALID_FACTORS.includes(factorId)) return;
  try {
    window.localStorage.setItem(LAST_USED_FACTOR_STORAGE_KEY, factorId);
  } catch {
    // Storage disabled (private mode / quota): degrade to no preference.
  }
}

// Returns the cached factor id, or null when there is no usable preference.
export function getLastUsedFactor() {
  try {
    const value = window.localStorage.getItem(LAST_USED_FACTOR_STORAGE_KEY);
    return VALID_FACTORS.includes(value) ? value : null;
  } catch {
    return null;
  }
}
